import { leaguesV2Api } from "../leaguesV2Api";
import type { Clubhouse_LeagueOperatorDetailDto } from "../../types/leagueDetails";

const leagueDetailEndpoints = leaguesV2Api.injectEndpoints({
  endpoints: (build) => ({
    getLeague: build.query<Clubhouse_LeagueOperatorDetailDto, string>({
      query: (leagueId) => `/api/leagues/${leagueId}/detail`,
      providesTags: (_, __, leagueId) => [{ type: "League", id: leagueId }],
    }),
  }),
});

export const { useGetLeagueQuery } = leagueDetailEndpoints;
